export enum termsConditionsInputType {
  LINK = 'link',
  TEXT = 'text'
}
